// Inquiry Redux Slice

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { inquiryApi } from '../../api/inquiryApi';

// ─── Async Thunks ──────────────────────────────────────────────────────────────

export const fetchInquiries = createAsyncThunk(
  'inquiries/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await inquiryApi.getList(params);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load inquiries');
    }
  }
);

export const fetchInquiryDetail = createAsyncThunk(
  'inquiries/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const res = await inquiryApi.getDetail(id);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load inquiry detail');
    }
  }
);

// ─── Slice ────────────────────────────────────────────────────────────────────

const inquirySlice = createSlice({
  name: 'inquiries',
  initialState: {
    list: [],
    total: 0,
    loading: false,
    error: null,
    detail: null,
    detailLoading: false,
    detailError: null,
  },
  reducers: {
    clearError:  (state) => { state.error = null; },
    clearDetail: (state) => { state.detail = null; state.detailError = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInquiries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInquiries.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.list  = payload.inquiries ?? payload;
        state.total = payload.total ?? (payload.inquiries?.length ?? 0);
      })
      .addCase(fetchInquiries.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(fetchInquiryDetail.pending, (state) => {
        state.detailLoading = true;
        state.detailError = null;
        state.detail = null;
      })
      .addCase(fetchInquiryDetail.fulfilled, (state, { payload }) => {
        state.detailLoading = false;
        state.detail = payload;
      })
      .addCase(fetchInquiryDetail.rejected, (state, { payload }) => {
        state.detailLoading = false;
        state.detailError = payload;
      });
  },
});

export const { clearError, clearDetail } = inquirySlice.actions;
export default inquirySlice.reducer;
